// src/components/AddToHome.jsx
import React from "react";
import useAddToHome from "../hooks/useAddToHome";
import { Button } from "./ui/button";
import { useLocation } from "react-router-dom";

const AddToHome = () => {
  const { addToHome, prompt, isInstalled } = useAddToHome();
  const location = useLocation();

  // Don't show on portal routes
  if (location.pathname.startsWith('/portal/')) return null;

  if (isInstalled || !prompt) return null;

  return (
    <div className="z-[60] fixed bottom-32 right-6">
      <Button
        onClick={addToHome}
        className="glass-dark hover:bg-black/80 text-white rounded-full px-8 py-6 text-base font-bold shadow-2xl transition-all hover:scale-105 active:scale-95 border border-white/20"
      >
        Add to Home
      </Button>
    </div>
  );
};

export default AddToHome;
